import { EFeatureContainerSize } from '../settings';

export function getStandardFeatureContainerSize(items: number) {
  if (items === 7) {
    return EFeatureContainerSize.Xl;
  } else if (items === 5) {
    return EFeatureContainerSize.Md;
  }

  return EFeatureContainerSize.Xs;
}
